import { useState } from 'react';
import { hotRanking } from '@/mocks/home';

const tabs = [
  { key: 'all', label: '全部' },
  { key: '短视频', label: '短视频' },
  { key: '直播', label: '直播' },
  { key: '福利资源', label: '福利资源' },
];

export default function HotRanking() {
  const [tab, setTab] = useState('all');
  const list = tab === 'all' ? hotRanking : hotRanking.filter((item) => item.cat === tab);

  return (
    <section id="hot" className="bg-foreground-950 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
          <div>
            <p className="text-xs font-label font-medium text-accent-400 tracking-wide mb-2">
              热门内容排行
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50">
              近期高热度，一张榜看清
            </h2>
            <p className="mt-2 text-sm font-label text-background-200/80 max-w-xl">
              按热度排序，标注来源分类与时长，越往下密度越高，适合一次性扫完。
            </p>
          </div>

          <div className="flex items-center gap-1 p-1 rounded-full bg-background-50/10 flex-wrap">
            {tabs.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setTab(item.key)}
                className={[
                  'px-4 py-2 rounded-full text-sm font-label transition-colors cursor-pointer whitespace-nowrap',
                  tab === item.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-background-200/80 hover:text-background-50',
                ].join(' ')}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-background-50/10 overflow-hidden">
          {list.map((item, index) => (
            <article
              key={item.rank}
              className="group flex items-center gap-3 md:gap-5 px-3 md:px-5 py-3.5 border-b border-background-50/10 last:border-b-0 hover:bg-background-50/5 transition-colors cursor-pointer"
            >
              <span
                className={[
                  'w-8 md:w-10 shrink-0 text-center font-heading font-black text-lg md:text-xl',
                  index < 3 ? 'text-primary-400' : 'text-background-200/50',
                ].join(' ')}
              >
                {item.rank}
              </span>

              <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-md overflow-hidden bg-background-50/10">
                <img
                  src={item.cover}
                  alt={`小蓝视频热门内容 ${item.title}`}
                  title={`小蓝视频热门内容 ${item.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-label text-sm md:text-base font-medium text-background-50 truncate group-hover:text-primary-300 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-background-50/12 text-[11px] font-label text-background-200/90 whitespace-nowrap">
                    {item.cat}
                  </span>
                </div>
                <div className="mt-2 flex items-center gap-3">
                  <span className="hidden sm:flex items-center gap-1 text-[11px] font-label text-background-200/70">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                  <span className="flex-1 max-w-[220px] h-1.5 rounded-full bg-background-50/15 overflow-hidden">
                    <span
                      className="block h-full rounded-full bg-accent-500"
                      style={{ width: `${item.heat}%` }}
                    ></span>
                  </span>
                  <span className="text-[11px] font-label text-accent-400 whitespace-nowrap">
                    热度 {item.heat}
                  </span>
                </div>
              </div>

              <i className="ri-arrow-right-s-line text-background-200/50 group-hover:text-primary-400 transition-colors"></i>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="py-10 text-center text-sm font-label text-background-200/70">
            该分类下暂时还没有热门内容
          </p>
        )}
      </div>
    </section>
  );
}